import QRCode from 'qrcode.react';
import { jsPDF } from 'jspdf';
// eslint-disable-next-line no-unused-vars
import { Button,Row,Col, Modal, Image } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import Table from 'react-bootstrap/Table';
// eslint-disable-next-line no-unused-vars
import avatarImage from 'assets/img/usuario-micuenta.svg';
import linkicon from 'assets/img/link_icon.svg'
import uploadicon from 'assets/img/uploap.png'
import { useState } from 'react';
import { Link } from 'react-router-dom'
import styles from './styles.module.scss';
import { SHARE_LINKS } from './config';

const LABEL_ONE = 'Usa este código para ingresar a mi mesa....';
const LABEL_TWO = 'Pruebalo activando la cámara de tu celular, escaneando';
const LABEL_TREE = 'el código y dando tap a la notificación';


(function textAlaing(API) {
  API.myText = function (txt, options, x, y) {
    options = options || {};
    /* Use the options align property to specify desired text alignment
     * Param x will be ignored if desired text alignment is 'center'.
     * Usage of options can easily extend the function to apply different text
     * styles and sizes
     */
    if (options.align === 'center') {
      // Get current font size
      const fontSize = this.internal.getFontSize();

      // Get page width
      const pageWidth = this.internal.pageSize.width;

      // Get the actual text's width
      /* You multiply the unit width of your string by your font size and divide
       * by the internal scale factor. The division is necessary
       * for the case where you use units other than 'pt' in the constructor
       * of jsPDF.
       */
      const txtWidth =
        (this.getStringUnitWidth(txt) * fontSize) / this.internal.scaleFactor;

      // Calculate text's x coordinate
      x = (pageWidth - txtWidth) / 2;
    }

    // Draw text at x,y
    this.text(txt, x, y);
  };
})(jsPDF.API);

const PrintQr = ({ url, title, evento, celebrate, image}) => {

  // console.log('evento', evento);
  const downloadQRCode = async () => {
    const canvas = document.getElementById('qr-gen');
    const jpgUrl = canvas
      ?.toDataURL('image/jpg')
      ?.replace('image/jpg', 'image/octet-stream');

    const pdf = new jsPDF({ format: [250, 250] });
    pdf.myText(title, { align: 'center' }, 0, 20);
    pdf.myText(LABEL_ONE, { align: 'center' }, 0, 30);
    pdf.myText(LABEL_TWO, { align: 'center' }, 0, 40);
    pdf.myText(LABEL_TREE, { align: 'center' }, 0, 45);
    pdf.addImage(jpgUrl, 'jpg', 78, 65, 95, 95);
    pdf.myText(url, { align: 'center' }, 0, 180);
    pdf.save('CodigoQr.pdf');
  };

  const [showModal, setShowModal] = useState(false);
  const handleClick = () => {
    if ( url) {
      navigator.clipboard.writeText(url);
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    }
  };
  const [showLinks, setShowLinks] = useState(false);

  const toggleLinks = () => {
    setShowLinks(!showLinks);
  };

  // console.log('url', url);

  return (
      <div className="text-center">
        <div>
          <h4><b>Usa este código para ingresar a mi mesa</b></h4>
          <p>Pruébalo activando la cámara de tu celular, escaneando el código y dando tap a la notificación</p>
          <br/><br/>
        </div>
        <Row>
          <Col className={styles?.divmarco}>
            <div className={styles?.imgposition}>
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              {image ? (
                  <img src={image} width="80" height="80" className={styles?.imageframe} />
              ) : (
                  <img src={avatarImage} width="80" height="80" className={styles?.imageframe} />
              )}
            </div>
            <div>
              {celebrate ? (
                  <h4>
                    <b>{celebrate}</b>
                  </h4>
              ) : (
                  <h4>
                    <b>Festejado</b>
                  </h4>
              )}
            </div>
            {evento ? (
                <div>{evento}</div>
            ) : (
                <div>Te invito</div>
            )}
            <div className="d-flex justify-content-center align-items-center">
              <QRCode value={url} id="qr-gen" size={250} />
            </div>
          </Col>
          <Col className="d-flex flex-column justify-content-center align-items-center">
            <div className="text-left">
              <div>
                <a className="colora" onClick={toggleLinks}>
                  <img src={uploadicon} alt="copiar link" style={{ width: '20px' }} /> Compartir mi mesa
                </a>
                {showLinks && (
                    <div style={{ display: 'flex' }}>
                      {SHARE_LINKS.map(({ id, icon, alt, getLink }) => (
                          <div key={id}>
                            <a
                                href={getLink(url)}
                                alt={alt}
                                className={`${styles?.control}`}
                                /* onClick={id === 'facebook' && shareFacebook} */
                                rel={id === 'twitter' && 'noreferrer'}
                                target='_blank'
                            >
                              <Image src={icon} alt={alt} />&nbsp;
                            </a>
                          </div>
                      ))}
                    </div>
                )}
              </div>
              <div>
                <Link
                  onClick={handleClick}
                  className={styles?.copyLinkButtonMinimalist }
                >
                  <img src={linkicon} alt="copiar link" style={{ width: '20px'}}/>  Copiar enlace
                </Link>
                {/* <a href="#"><i className="fa fa-link" aria-hidden="true" />  Copiar enlace</a> */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                  <Modal.Body>Copiado</Modal.Body>
                </Modal>
                </div>
              <div>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" onClick={downloadQRCode}><i className="fa fa-download" aria-hidden="true" style={{ width: '20px', textAlign:'center'}}/>  Guardar en mis fotos</a></div>
            </div>
          </Col>
        </Row>
      </div>


      /* colSpan={2}
      <div className="text-center">
        <h3 className="font-weight-bold">{LABEL_ONE} </h3>
        <h3>{`${LABEL_TWO} ${LABEL_TREE}`}</h3>

        <div className={styles?.qrCode}>
          <QRCode value={url} id="qr-gen" size={250} />
        </div>
        <div style={{ display: 'grid' }}>
          <a
            style={{ textAling: 'center', marginBottom: '10px' }}
            rel="noreferrer"
            target="_blank"
            href={url}
          >
            {url}
          </a>
          <Button onClick={downloadQRCode}>Descargar código QR</Button>
        </div>
      </div>
      */
  );
};

export default PrintQr;
